
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function TransactionIconFocused(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <Path
        d="M6.5 21.5h12A1.5 1.5 0 0020 20V8l-3.621-.805a1.5 1.5 0 01-1.12-1.063L14.25 2.5H6.5A1.5 1.5 0 005 4v16a1.5 1.5 0 001.5 1.5z"
        fill="#2D57D9"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.523 18.622a.504.504 0 00.417-.039.44.44 0 00.17-.2.427.427 0 00.034-.262.454.454 0 00-.13-.229l-2.825-2.948h.561a2.86 2.86 0 001.952-.726c.523-.46.813-1.074.876-1.828h.706a.446.446 0 00.454-.455.446.446 0 00-.454-.454h-.74a2.824 2.824 0 00-.676-1.235h1.416c.12 0 .231-.038.32-.12a.424.424 0 00.134-.321.446.446 0 00-.454-.455h-5.48a.446.446 0 00-.454.455c0 .124.042.236.134.322.09.081.2.119.32.119h1.946c.472 0 .883.136 1.24.406.302.23.505.505.615.829h-3.8a.446.446 0 00-.455.454.445.445 0 00.455.455h3.875c-.053.513-.256.902-.602 1.182a2.05 2.05 0 01-1.328.477h-1.125a.636.636 0 00-.463.19.636.636 0 00-.19.463c0 .092.02.186.057.279a.679.679 0 00.145.236l3.183 3.289a.35.35 0 00.166.116zm.47-.357a.346.346 0 01-.02.056c-.052.12-.15.179-.29.179a.354.354 0 01-.113-.02.202.202 0 01-.1-.073l-3.189-3.295a.532.532 0 01-.113-.185.621.621 0 000 0c.031.079.069.14.113.185l3.19 3.295c.026.036.06.06.099.073.04.014.077.02.112.02.142 0 .239-.06.292-.179a.342.342 0 00.02-.056zm-2.243-3.47h-.913.913a2.71 2.71 0 001.853-.69 2.376 2.376 0 000 .001 2.71 2.71 0 01-1.853.688zm2.687-2.555h.847-.847zm.847-2.144h-1.826 1.826a.31.31 0 010 0zM9.5 9.805c0 .088.029.158.086.211a.31.31 0 00.219.08h1.945c.503 0 .946.145 1.33.436.384.291.624.658.722 1.099a1.861 1.861 0 00-.721-1.098 2.14 2.14 0 00-1.33-.437H9.804a.31.31 0 01-.219-.08.274.274 0 01-.086-.211zm0 2.13c0 .088.029.161.086.219.057.057.13.086.219.086h4.036-4.036a.296.296 0 01-.304-.304z"
        fill="#fff"
      />
      <Path d="M14.25 6.5v-4L20 8h-4.25a1.5 1.5 0 01-1.5-1.5z" fill="#DDEAFF" />
    </Svg>
  )
}

export default TransactionIconFocused